import { render, staticRenderFns } from "./AuthLogin.vue?vue&type=template&id=4060644e&"
import script from "./AuthLogin.vue?vue&type=script&lang=js&"
export * from "./AuthLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports